/**
 * Centralized URL constants for the application.
 * 
 * SITE_URL: The public-facing domain of the application.
 * Used for building canonical URLs, structured data, SEO metadata,
 * and search indexing queue entries.
 * 
 * This is the BUSINESS DOMAIN — it does not change with server region migrations.
 * For Supabase infrastructure URLs, use environment variables instead.
 */
export const SITE_URL = 'https://paperverse.io';

/**
 * The domain name without protocol, used for twitter:domain and similar meta tags.
 */
export const SITE_DOMAIN = 'paperverse.io';
